import { ref, nextTick } from 'vue';

/**
 * Composable для управления тултипом акций MOEX.
 * Позиционирует тултип над элементом-якорем с автокоррекцией по горизонтали.
 */
export function useStockTooltip() {
  const tooltipRef = ref(null);
  const showTooltip = ref(false);
  const tooltipStyle = ref({});
  let closeTimer = null;

  const positionTooltip = (anchorEl) => {
    if (!anchorEl) return;
    const rect = anchorEl.getBoundingClientRect();
    tooltipStyle.value = {
      position: 'fixed',
      left: `${rect.left + rect.width / 2}px`,
      top: `${rect.top - 8}px`,
      transform: 'translate(-50%, -100%)',
      zIndex: 99999,
    };
  };

  const clampBounds = () => {
    if (!tooltipRef.value) return;
    const tRect = tooltipRef.value.getBoundingClientRect();
    const margin = 8;
    let left = parseFloat(tooltipStyle.value.left);
    if (tRect.left < margin) {
      left += margin - tRect.left;
    } else if (tRect.right > window.innerWidth - margin) {
      left -= tRect.right - (window.innerWidth - margin);
    }
    tooltipStyle.value = { ...tooltipStyle.value, left: `${left}px` };
  };

  const open = async (anchorEl) => {
    clearTimeout(closeTimer);
    positionTooltip(anchorEl);
    showTooltip.value = true;
    await nextTick();
    clampBounds();
  };

  const scheduleClose = () => {
    closeTimer = setTimeout(() => { showTooltip.value = false; }, 80);
  };

  const cancelClose = () => {
    clearTimeout(closeTimer);
  };

  const close = () => {
    showTooltip.value = false;
  };

  return {
    tooltipRef,
    showTooltip,
    tooltipStyle,
    open,
    close,
    scheduleClose,
    cancelClose,
  };
}
